import { RUN_STATES } from "components/Run/elements/StateBadge";
import Badge from "ds/components/Badge";
import { RunState } from "types/generated";

import { ModulePullRequestState } from "../helpers";

// Icons and variants are borrowed from the run states these aggregate.
const STATES: Record<ModulePullRequestState, (typeof RUN_STATES)[RunState]> = {
  [ModulePullRequestState.QUEUED]: RUN_STATES[RunState.Queued],
  [ModulePullRequestState.IN_PROGRESS]: RUN_STATES[RunState.Applying],
  [ModulePullRequestState.FAILED]: RUN_STATES[RunState.Failed],
  [ModulePullRequestState.FINISHED]: RUN_STATES[RunState.Finished],
};

type ModulePullRequestStateBadgeProps = {
  state: ModulePullRequestState;
};

const ModulePullRequestStateBadge = ({ state }: ModulePullRequestStateBadgeProps) => (
  <Badge
    startIcon={STATES[state].icon}
    variant={STATES[state].variant || "gray"}
    type="strong"
    text={state}
  />
);

export default ModulePullRequestStateBadge;
